import axios from '@/utils/axios'

// 获取我的推荐数据
export function MyRecommendgGet (params = {}) {
  return axios({
    url: '/Member/RecommendCycle/MyRecommendgGet',
    method: 'get',
    params: params
  })
}
// 获取推荐好友列表
export function RecommendFriendList (params = {}) {
  return axios({
    url: '/Member/RecommendCycle/RecommendFriendList',
    method: 'get',
    params: params
  })
}
// 获取推荐排行榜列表
export function RecommendRankList (params = {}) {
  return axios({
    url: '/Member/RecommendCycle/RecommendRankList',
    method: 'get',
    params: params
  })
}
// 获取免单卡配置
export function AwardFreeCardConfig (params = {}) {
  return axios({
    url: '/Member/RecommendCycle/AwardFreeCardConfig',
    method: 'get',
    params: params
  })
}
// 获取历史排行榜
export function RecommendHistoryList (params = {}) {
  return axios({
    url: '/Member/RecommendCycle/RecommendHistoryList',
    method: 'get',
    params: params
  })
}
